import { CommonModule, formatCurrency } from '@angular/common';
import { Component, OnInit, signal, Signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertController, IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/pipes/pipes.module';
import { AppStoreService, DonateProduct } from 'src/services/app-store.service';
import { ComponentsModule } from '../components.module';

@Component({
    standalone: true,
    imports: [IonicModule, FormsModule, CommonModule, PipesModule, TranslateModule, ComponentsModule],
    selector: 'boulders',
    template: `
    <ion-header>
        <ion-toolbar class="emoji-modal-toolbar">
            <ion-title *ngIf="!appStoreService.isSupporter()">{{"donate-component.title" | translate}}</ion-title>
            <ion-buttons slot="end">
                <ion-button color="primary" (click)="dismiss()">
                <ion-icon name="close-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
    <loader [timeoutInSeconds]="20" *ngIf="isLoading"></loader>
    <h1>{{"donate-component.header" | translate}}</h1>
    @if(appStoreService.isSupporter()) {
        <h2>{{"donate-component.thank-you" | translate}}</h2>
        <h1 class="heart-icon"><ion-icon name="heart-outline"></ion-icon></h1>
    }
     <ion-item>
        <ion-radio-group [value]="selectedProduct" (ionChange)="handleChange($event)">
             <ion-item *ngFor="let product of products()">
                <ion-radio [value]="product.productId" justify="end">{{ product.price }}</ion-radio>
            </ion-item>
             <ion-item *ngIf="false">
                <ion-input (blur)="transformAmount($event)" [(ngModel)]="formattedAmount" [maxlength]="3" slot="start" type="text" placeholder='{{"donate-component.title" | translate}}'></ion-input>
                <ion-radio slot="start" [value]="formattedAmount"></ion-radio>
            </ion-item>
        </ion-radio-group>
     </ion-item>
     <ion-item *ngIf="false">
        <ion-checkbox justify="end">Jährlich spenden</ion-checkbox>
     </ion-item>
     <ion-grid>
    <ion-row>
      <ion-col col-4>
      </ion-col>
      <ion-col col-4>
        <ion-button *ngIf="products()?.length > 0" color="primary" size="large" (click)="donate()">{{"donate-component.donate-now" | translate}}</ion-button>
      </ion-col>
      <ion-col col-4>
      </ion-col>
    </ion-row>
    </ion-grid>
    </ion-content>
  `,
    styleUrls: ['./donate.component.scss'],
})
export class DonateComponent implements OnInit {

    isLoading = false;
    formattedAmount: string;
    amount: number;
    selectedProduct = 'basicsupporter';

    products: Signal<DonateProduct[]>;
    constructor(
        private alertController: AlertController,
        private modalController: ModalController,
        public appStoreService: AppStoreService) {
    }

    public dismiss() {
        this.modalController.dismiss();
    }

    public async donate() {
        this.isLoading = true;
        try {
            const value = await this.appStoreService.purchase(this.selectedProduct);
            if (value) {
                const alert = await this.alertController.create({
                    header: 'Error while donating',
                    message: 'Donation could not be processed. Please try again later. ' + value?.message,
                    buttons: [{
                        text: 'OK',
                        role: 'confirm',
                        handler: () => {
                            this.dismiss();
                        },
                    }],
                });
                await alert.present();
            } else {
                const alert = await this.alertController.create({
                    header: '❤️ THANK YOU ❤️',
                    buttons: [{
                        text: 'OK',
                        role: 'confirm',
                        handler: () => {
                            this.dismiss();
                        },
                    }],
                });
                await alert.present();
            }
        } catch (e) {
            console.error('Error purchasing product', e);
        }
        this.isLoading = false;
    }

    ngOnInit() {
        this.products = this.appStoreService.getProducts();
        this.selectedProduct = this.products().length > 0 ? this.products()[0].productId : '';
    }
    transformAmount(element) {
        this.formattedAmount = formatCurrency(this.amount, 'EN', '€');
        element.target.value = this.formattedAmount;
    }

    handleChange(ev) {
        this.selectedProduct = ev.detail.value;
    }

}
